document.querySelectorAll('.typewriter').forEach(el => {
  const headlines = JSON.parse(el.dataset.typewriters);
  let headlineIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  const TYPE_SPEED = 120;  // war 80  → langsamer tippen
  const DELETE_SPEED = 70;   // war 40  → langsamer löschen
  const PAUSE_END = 2500; // war 1800 → länger stehen bleiben
  const PAUSE_START = 500;

  const tick = () => {
    const current = headlines[headlineIndex];

    if (!isDeleting) {
      // Tippen
      el.textContent = current.slice(0, ++charIndex);

      if (charIndex === current.length) {
        // Text vollständig → Pause, dann löschen
        isDeleting = true;
        setTimeout(tick, PAUSE_END);
        return;
      }
    } else {
      // Löschen
      el.textContent = current.slice(0, --charIndex);

      if (charIndex === 0) {
        // Leer → nächste Headline
        isDeleting = false;
        headlineIndex = (headlineIndex + 1) % headlines.length;
        setTimeout(tick, PAUSE_START);
        return;
      }
    }

    setTimeout(tick, isDeleting ? DELETE_SPEED : TYPE_SPEED);
  };

  tick();
});